export default `
  mutation purgeOrganisation($id: String!) {
    purgeOrganisation(id: $id) {
        id
        snapshotKey
        projectsDeleted
        workflowsSnapshotted
        membersDeleted
        aiUsageDeleted
      }
  }
`
